import React from 'react';
import { useTranslation } from 'react-i18next';

import { useRevampThemePerformanceReturn } from '../hooks/useThemePerformanceReturn';
import { Horizon } from '../ThemePerformanceSection';
import * as S from './HorizonItem.styles';

interface HorizonItemProps {
  horizonToIndexMap: Map<string, number>;
  horizon: Horizon;
  isSelected: boolean;
  benchmarkTags?: string[];
  onClick: () => void;
  themeId: string;
}

export const HorizonItem = ({
  benchmarkTags,
  horizon,
  horizonToIndexMap,
  isSelected,
  onClick,
  themeId,
}: HorizonItemProps) => {
  const { t } = useTranslation(['widget', 'scenario']);

  const {
    value: revampValue,
    isNegative: revampIsNegative,
    isLoading: revampIsLoading,
  } = useRevampThemePerformanceReturn({
    themeId,
    selectedHorizon: horizon,
    benchmarkTags,
    numDays: horizonToIndexMap.get(horizon.toLowerCase()),
  });

  const dataToUse = {
    value: revampValue,
    isNegative: revampIsNegative,
    isLoading: revampIsLoading,
  };

  const horizonTranslationMap: Record<Horizon, string> = {
    '1D': t('scenario:filters.horizons.1d'),
    '1W': t('scenario:filters.horizons.1w'),
    '1M': t('scenario:filters.horizons.1m'),
    '3M': t('scenario:filters.horizons.3m'),
    '6M': t('scenario:filters.horizons.6m'),
    '1Y': t('scenario:filters.horizons.1y'),
  };

  return (
    <S.HorizonWrapper $isSelected={isSelected} onClick={onClick}>
      <S.HorizonTitle>{horizonTranslationMap[horizon]}</S.HorizonTitle>
      <S.SecondRowWrapper>
        {benchmarkTags && (
          <S.HorizonPrefix>
            {t(
              `widget:themeOverview.tabs.overview.${
                dataToUse.isNegative ? 'horizonPrefixUp' : 'horizonPrefixOp'
              }`
            )}
          </S.HorizonPrefix>
        )}
        {dataToUse.isLoading ? (
          <S.StyledSkeletonLoader />
        ) : (
          <S.HorizonValue $isNegative={dataToUse.isNegative}>
            {dataToUse.value}
          </S.HorizonValue>
        )}
      </S.SecondRowWrapper>
    </S.HorizonWrapper>
  );
};
